import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "appLayout" }
const _hoisted_2 = { id: "navbar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "workspace" }, null, -1)
const _hoisted_4 = { id: "sidebarContent" }
const _hoisted_5 = { id: "routerView" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NavBar)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SidebarMenu),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.path
        }))
      ])
    ])
  ]))
}